<template>
  <v-text-field 
    ref="textField"
    :id="id" 
    :color="PrimaryColor" 
    autocomplete="null" 
    :hide-details="hideDetails" 
    @keydown="Onkeydown" 
    @keyup.enter="onEnter" 
    hide-spin-buttons 
    :loading="loading" 
    :prefix="prefix" 
    :style="styleProp" 
    :disabled="disabled" 
    :value="vmodel" 
    :counter="counter" 
    :hint="hint" 
    :backgroundColor="backgroundColor" 
    outlined 
    :label="title" 
    @input="handleInput" 
    :rules="rulesInput" 
    :type="type" 
    :maxlength="maxlength"  
    @wheel="$event.target.blur()"
    @blur="validateField"
  />
</template>

<script>
import { cleanForSP } from "@/utils/sanitizeForSP";
export default {
  props:
  {
    vmodel:
    {
      type:String,
      default:undefined,
      required:false
    },
    disabled:
    {
      type:Boolean,
      default:false,
    },
    loading:
    {
      type:Boolean,
      default:false,
    },
    mask:
    {
      type:String,
      default:undefined,
      required:false
    },
    hint:
    {
      type:String,
      default:"",
      required:false
    },
    counter:
    {
      type:Number,
      default:undefined,
      required:false
    },
    title:
    {
      required:true,
      type:String
    },
    onBlur:
    {
      required:false,
      default:() => {},
      type:Function
    },
    onChange:
    {
      required:false,
      default:() => {},
      type:Function
    },
    Onkeydown:
    {
      required:false,
      default:() => {},
      type:Function
    }, 
    onInput:
    {
      required:false,
      default:() => {},
      type:Function
    },
    onEnter:
    {
      required:false,
      default:() => {},
      type:Function
    },
    rulesSelected:
    {
      default:() => []
    },
    type:
    {
      required:false,
      type:String,
      default:"text"
    },
    prefix: {
      required:false,
      default:"",
      type:String
    },
    maxlength: {
      required:false,
      type:Number
    },
    styleProp: {
      type:String,
      required:false,
      default:"margin:0px 0;"
    },
    backgroundColor: {
      type:String,
      required:false,
      default:"#EBF1F4"
    },
    hideDetails:
    {
      required:false,
      default:false
    },
    id:{
      required:false,
      default:undefined
    },
  },
  data()
  {
    return {
      rulesInput:[],

    }
  },
  mounted()
  {
    for (const rule of this.rulesSelected) 
    {
      if(typeof(rule) === "string")
      {
        // Create a function that calls the rule with the current value
        this.rulesInput.push((value) => this.$store.state.Misc.rules[rule](value));
      }
      else
      {
        const NombreRegla = (rule)[0];
        const Parametros = (rule)[1];
        this.rulesInput.push(this.$store.state.Misc.rules[NombreRegla](this.vmodel,Parametros));
      }
    }
  },
    watch:
    {
      rulesSelected()
      {
        this.updateRules();
      },
      vmodel()
      {
        this.updateRules();
        // Force validation when value changes
        this.$nextTick(() => {
          if (this.$refs.textField) {
            this.$refs.textField.validate();
          }
        });
      },
      counter()
      {
        this.updateRules();
      }
  },
  methods: {
    updateRules() {
      this.rulesInput = [];
      for (const rule of this.rulesSelected) 
      {
        if(typeof(rule) === "string")
        {
          this.rulesInput.push((value) => this.$store.state.Misc.rules[rule](value));
        }
        else
        {
          const NombreRegla = (rule)[0];
          const Parametros = (rule)[1];
          this.rulesInput.push(this.$store.state.Misc.rules[NombreRegla](this.vmodel,Parametros));
        }
      }
      this.$nextTick(() => {
        if (this.$refs.textField) {
          this.$refs.textField.validate();
        }
      });
    },
    handleInput(value) {
      this.onChange(cleanForSP(value));
      this.$nextTick(() => {
        if (this.$refs.textField && this.$refs.textField.$refs.input) {
          this.$refs.textField.$refs.input.value = this.vmodel;
        }
      });
    },
    validateField() {
      if (this.$refs.textField) {
        this.$refs.textField.validate();
      }
    }
  }
}
</script>
